
















































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ascending } from 'd3-array';
import { ContentLoader } from 'vue-content-loader';
import CardLoader from '@/components/UI/Loader/CardLoader.vue';
import { IExclusion, LoadState } from '@/store/types';
import { capitalizeFirstLetter, LOAD_STATE, romanize, SEGMENT_OPERAND, SEGMENT_ATTRIBUTE, CUSTOM_ATTRIBUTE_TYPE } from '@/store/shared';
import { FETCH_REACTIVATION_BLOCK_COUNTS, SYNC_REACTIVATION } from '@/store/action-types';

enum ExclusionState {
  disabled = 'disabled',
  active = 'active',
  setup = 'setup',
}

export default Vue.extend({
  name: 'ExclusionCard',
  components: {
    ContentLoader,
    CardLoader,
  },
  props: {
    exclusionId: {
      type: String,
    },
    placeholder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      LOAD_STATE,
      ExclusionState,
    };
  },
  async created() {
    if (!this.placeholder && this.exclusionId && !this.exclusion) {
      await this.$store.dispatch(SYNC_REACTIVATION);
    }
  },
  computed: {
    ...mapGetters(['reactivationExclusions']),
    campaignBlockCount(): number | undefined {
      if (this.$store.state.reactivationBlockCountsLoadState !== LOAD_STATE.LOADED) {
        return undefined;
      }
      if (this.exclusion?._id) {
        return this.$store.state.reactivationBlockCounts[this.exclusion?._id] || 0;
      }
      return 0;
    },
    exclusion(): IExclusion | undefined {
      if (this.placeholder) {
        const updated = new Date().toISOString();
        return {
          _id: '',
          guid: '',
          name: 'Example Exclusion',
          enabled: true,
          publishedCopies: [],
          updatedAt: updated,
          publishedAt: updated,
          filters: [
            {
              attribute: SEGMENT_ATTRIBUTE.SUBSCRIPTION_AGE_MONTHS,
              operand: SEGMENT_OPERAND.BETWEEN,
              value: [4, 12],
            },
            {
              attribute: 'Margin',
              operand: SEGMENT_OPERAND.BETWEEN,
              value: [0.5, 0.7],
              type: CUSTOM_ATTRIBUTE_TYPE.NUMBER,
            },
          ],
        };
      }
      if (!this.exclusionId) {
        return undefined;
      }
      return this.$store.state.reactivationExclusions?.[this.exclusionId];
    },
    unpublishedChanges(): boolean {
      if (this.exclusion) {
        return this.exclusion.updatedAt !== this.exclusion.publishedAt;
      }
      return false;
    },
    exclusionState(): ExclusionState {
      if (!this.exclusion?.publishedAt || !this.exclusion.filters.length) {
        return ExclusionState.setup;
      }
      if (!this.exclusion?.enabled) {
        return ExclusionState.disabled;
      }
      return ExclusionState.active;
    },
    exclusionLoadState(): LoadState {
      if (this.exclusionId) {
        return this.exclusion?.loadState || LOAD_STATE.UNLOADED;
      }
      return LOAD_STATE.LOADED;
    },
    loadState(): LoadState {
      if (this.exclusionLoadState === LOAD_STATE.LOADED) {
        return LOAD_STATE.LOADED;
      }
      return LOAD_STATE.LOADING;
    },
    description(): string {
      if (this.exclusion) {
        const filters = this.exclusion.filters || [];
        const filterStrings = filters.map((f) => this.$store.getters.segmentFilterToString(f));
        if (filterStrings.length) {
          if (filterStrings.length > 1) {
            return filterStrings.map((s, i) => `(${romanize(i + 1).toLowerCase()}) ${capitalizeFirstLetter(s.toLowerCase())}`).join(', and ');
          }
          return capitalizeFirstLetter(filterStrings.join(' & ').toLowerCase());
        }
      }
      return 'To be defined';
    },
  },
});
